<template>
  <footer class="mt-auto flex w-full flex-col">
    <div class="flex justify-center bg-blue-50">
      <div class="p-lg max-w-content flex items-center">
        <img
          src="~/assets/images/illustrations/app-mockup-3d.png"
          alt=""
          width="205"
          class="max-laptop:hidden"
        />

        <div class="flex flex-col">
          <p class="text-large font-semibold text-gray-600">
            Téléchargez notre application
          </p>
          <p class="mt-md text-h1 text-blue-500">
            Vos sorties et événements locaux toujours à portée de main
          </p>

          <div class="gap-lg mt-md flex flex-wrap items-center justify-center">
            <NuxtLink
              to="https://play.google.com/store/apps/details?id=com.sopheos.agenda&utm_source=org&utm_medium=referral&utm_campaign=app_install&utm_content=footer"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="~/assets/images/google-play.png"
                :alt="`Télécharger l'application Agenda.org sur GooglePlay - ouvre une nouvelle fenêtre`"
                class="h-10 w-33"
              />
            </NuxtLink>

            <NuxtLink
              to="https://apps.apple.com/fr/app/apple-store/id6793108859?pt=96893923&ct=app_install_org_footer&mt=8"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="~/assets/images/app-store.png"
                :alt="`Télécharger l'application Agenda.org sur AppStore - ouvre une nouvelle fenêtre`"
                class="h-10 w-33"
              />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <div
      class="gap-sm laptop:flex-row laptop:gap-xxl laptop:items-end p-lg laptop:justify-center flex flex-col justify-end"
    >
      <div class="flex h-min items-center justify-center">
        <GButton
          id="show-cgu"
          class="self-center"
          data-role="link"
          @click="showCgu"
          >Conditions générales d'utilisation</GButton
        >
      </div>

      <div class="flex h-min items-center justify-center">
        <GButton
          id="show-confidentialite"
          data-role="link"
          class="self-center"
          @click="showConfidentiality"
          >Politique de confidentialité</GButton
        >
      </div>

      <div class="flex h-min items-center justify-center">
        <GLink to="https://info.agenda.org/"> Nous contacter </GLink>
      </div>

      <AppDialog
        ref="dialog"
        :aria-label="type === CGU ? 'CGU' : 'Politique de confidentialité'"
        class="dialog-full laptop:dialog-center laptop:[--dialog-width:var(--breakpoint-content)]"
        @click-out="dialog?.close()"
      >
        <header class="p-xs flex justify-end bg-blue-50">
          <GButton aria-label="Fermer" @click="dialog.close()">
            <template #icon>
              <Icon name="fa6-solid:x" />
            </template>
          </GButton>
        </header>
        <section class="p-sm">
          <GMarkdown v-if="content" :data="content" />

          <div v-else-if="loading" class="flex justify-center">
            <GSpinner class="text-6xl text-blue-500" />
          </div>

          <div v-else class="flex justify-center">
            <div class="w-form gap-sm flex flex-initial flex-col">
              <p>
                {{ useErrorWording("http", 500, "default") }}
              </p>

              <GButton @click="reload()"> Recharger </GButton>
            </div>
          </div>
        </section>
      </AppDialog>
    </div>
  </footer>
</template>

<script setup>
const dialog = useTemplateRef("dialog");

const fetchApi = useFetchApi();

const CGU = 1;
const CONFIDENTIALITE = 2;

const type = ref(null);
const cgu = ref(null);
const confidentialite = ref(null);

const loading = ref(true);

const content = computed(() => {
  switch (type.value) {
    case CGU:
      return cgu.value;
    case CONFIDENTIALITE:
      return confidentialite.value;
    default:
      return null;
  }
});

async function reload() {
  switch (type.value) {
    case CGU:
      cgu.value = await loadCgu();
      break;
    case CONFIDENTIALITE:
      cgu.value = await loadConfidentiality();
      break;
    default:
      return null;
  }
}

async function showCgu() {
  dialog.value?.showModal();
  type.value = CGU;
  if (!cgu.value) {
    cgu.value = await loadCgu();
  }
}

function loadCgu() {
  loading.value = true;
  return fetchApi
    .get("/v1/document/cgu")
    .then(({ body }) => body)
    .catch(() => null)
    .finally(() => {
      loading.value = false;
    });
}

async function showConfidentiality() {
  dialog.value?.showModal();
  type.value = CONFIDENTIALITE;
  if (!confidentialite.value) {
    confidentialite.value = await loadConfidentiality();
  }
}

function loadConfidentiality() {
  loading.value = true;
  return fetchApi
    .get("/v1/document/confidentialite")
    .then(({ body }) => body)
    .catch(() => null)
    .finally(() => {
      loading.value = false;
    });
}
</script>
